/**
 * Created by stonewang on 2020/12/05.
 */
import {config, request, objectSerial} from 'Utils';

/**
 * 商品新增
 * @param param
 * {
    "name": "TGQ3塑壳断路器", //商品名称
    "proBigType": "330", //商品大类
    "proMiddleType": "33001", //商品中类
    "proDetailType": "3300107", //商品小类
    "proCategoryId": 11257, //商品小类中的分类id
    "groupCode": "hot_sale", //商品分组
    "seriesCode": "universal_series", //商品序列
    "partsTypeJson": "[{\"proBigType\":\"351\",\"proMiddleType\":\"35101\",\"proDetailType\":\"3510101\"}]", //商品配件类别，存储配件分类的大中小编码的json字符串数组
    "partCategoryIds": "11446", //配件小类中的分类id（多个配件category_id用英文逗号隔开）
    "picPreviewIds": "13131", //商品缩略图  ids，以逗号分隔
    "picMainIds": "13053,13059,13073", //商品主图 ids，以逗号分隔
    "description": "商品描述",
    "imageTextDetail": "图文详情",
    "commodityParameters": "商品参数",
    "productList": [
        {
            "id": 65, //产品id
            "isDefault": 1 //是否默认,1 默认，0 非默认
        },
        {
            "id": 71,
            "isDefault": 0
        }
    ]
}
 * */
export function addCommodity(param) {
  return request(`${config.server}/api/v1/dms/commodity/addCommodity`, {
    method: 'post',
    body: param
  });
}
/** 商品编辑*/
export function modifyCommodity(param) {
  return request(`${config.server}/api/v1/dms/commodity/modifyCommodity`, {
    method: 'post',
    body: param
  });
}
/** 商品列表*/
export function commodityList(param) {
  return request(`${config.server}/api/v1/dms/commodity/commodityList`, {
    method: 'post',
    body: param
  });
}
/** 商品选型库列表*/
export function commodityModelSelectionList(param) {
  return request(`${config.server}/api/v1/dms/commodity/commodityModelSelectionList`, {
    method: 'post',
    body: param
  });
}
/** 商品批量删除
 * param:
 *
 * {
    "ids": [
        "12"
    ],
    "status": 1
}
 *
 * */
export function deleteCommodity(param) {
  return request(`${config.server}/api/v1/dms/commodity/deleteCommodity`, {
    method: 'post',
    body: param
  });
}

/** 商品详情*/
export function commodityDetail(param) {
  return request(`${config.server}/api/v1/dms/commodity/commodityDetail`, {
    method: 'get',
    body: param
  });
}
/** 商品详情中的产品列表接口*/
export function productListForCommodity(param) {
  return request(`${config.server}/api/v1/dms/product/productListForCommodity`, {
    method: 'post',
    body: param
  });
}
/** 商品表单页面查询可选关联产品*/
export function getProductListPcForCommodity(param) {
  return request(`${config.server}/api/v1/dms/product/getProductListPcForCommodity`, {
    method: 'post',
    body: param
  });
}

/** 商品产品批量新增
 * param:
 *
 * {
    "id": 12, // 商品ID
    "productList": [
        {
            "id": 65,
            "isDefault": 1
        },
        {
            "id": 71,
            "isDefault": 0
        }
    ]
}
 *
 * */
export function addProductForCommodity(param) {
  return request(`${config.server}/api/v1/dms/commodity/addProduct/${param.id}`, {
    method: 'post',
    body: param
  });
}

/** 商品产品批量删除
 * param:
 *
 * {
    "id": 12, // 商品ID
    "productList": [
        {
            "id": 65,
            "isDefault": 1
        },
        {
            "id": 71,
            "isDefault": 0
        }
    ]
}
 *
 * */
export function delProductForCommodity(param) {
  return request(`${config.server}/api/v1/dms/commodity/delProduct/${param.id}`, {
    method: 'post',
    body: param
  });
}
/** 商品产品设置为默认或者取消默认
 * param:
 *
 * {
    "id": 12, // 商品ID
    "productId"： 1333， // 产品ID
    "isDefault"： 1, // 1-默认产品， 0-非默认产品
}
 *
 * */
export function setDefaultProductForCommodity(param) {
  return request(`${config.server}/api/v1/dms/commodity/setDefaultProduct/${param.id}`, {
    method: 'post',
    body: param
  });
}
// 成交记录
export function transactionRecord(param) {
  return request(`${config.server}/api/v1/dms/commodity/transactionRecord`, {
    method: 'post',
    body: {
      "commodityId": 33,
      "p": 1,
      "s": 20,
      ...param
    }
  });
}



// WEBPACK FOOTER //
// ./src/service/merchandise/index.js